const KEY_PREFIX = 'gecko_notes_'
const CURRENT_NOTE_KEY = KEY_PREFIX + 'current_note'
const LOGGED_IN_USER_KEY = KEY_PREFIX + 'logged_in_user'


export function getCurrentNote() {
    return getItem(CURRENT_NOTE_KEY)
}

export function setCurrentNote(data) {
    setItem(CURRENT_NOTE_KEY, data)
}

export function removeCurrentNote() {
    removeItem(CURRENT_NOTE_KEY)
}

export function getUser() {
    return getItem(LOGGED_IN_USER_KEY)
}

export function setUser(user) {
    setItem(LOGGED_IN_USER_KEY, user)
}

export function removeUser() {
    removeItem(LOGGED_IN_USER_KEY)
}

function getItem(key) {
    const item = localStorage.getItem(key)
    if (!item) {
        return null
    }

    try {
        return JSON.parse(item)
    } catch {
        return null
    }
}

function setItem(key, data) {
    localStorage.setItem(key, JSON.stringify(data))
}

function removeItem(key) {
    localStorage.removeItem(key)
}
